const APP_CONFIG = {
  version: "7.84.1",
  title: "Claire V7.84.1",
  version_client: "7.84.1",
};

export default APP_CONFIG;
